exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container---V2Xm- {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 45px;\n  margin: 0 auto; }\n\n.icon---25wPv {\n  float: left;\n  width: 30px;\n  height: 30px;\n  margin-right: 2px; }\n", ""]);

// exports
exports.locals = {
	"container": "container---V2Xm-",
	"icon": "icon---25wPv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/email-status/index.scss
// module id = 1155
// module chunks = 3